import { Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonService } from '../services/common/common.service';
import { menuList } from './menu';
import { Router } from '@angular/router';
import { JwtService } from '../auth/jwtservice';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrl: './left-nav.component.scss',
  animations: [
    trigger('slidein', [
      transition(':enter', [
        // when ngif has true
        style({ transform: 'translateX(-100%)' }),
        animate(250, style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        // when ngIf has false
        animate(250, style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})

export class LeftNavComponent implements OnInit {
  subMenuShouldOpenUp: boolean = false;
  isHovered: boolean = false;
  menu: any[] = [];
  userRoles: any;
  constructor(public commonService: CommonService, public router: Router, private jwtService: JwtService) {
  }

  async ngOnInit(): Promise<void> {
    this.userRoles = await firstValueFrom(this.jwtService.currentUserRole$());
    this.menu = this.getFilteredMenu();
  }

  getFilteredMenu() {
    return menuList.map(menu => {
      // Filter submenu items based on role
      const filteredSubMenu = menu?.subMenu?.filter((sub: any) =>
        !sub?.role || sub?.role.some((role: any) => this.userRoles?.includes(role))
      ) || [];
      // Return menu if it has visible submenus or it directly matches a role
      return {
        ...menu,
        subMenu: filteredSubMenu
      };
    }).filter(menu => menu.subMenu?.length > 0 || (menu?.role && menu?.role.some(role => this.userRoles?.includes(role)))
    );
  }

  onMouseEnter(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const submenu = target.querySelector('.hover-content') as HTMLElement;

    if (submenu) {
      const rect = submenu.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Decide whether to open upwards
      this.subMenuShouldOpenUp = spaceBelow < 150 && spaceAbove > spaceBelow;
    }
  }

  /**
   * method is used to hide on initial load left navigation bar when screen is in mobile view
   * @param url
   */
  hide(sub: any) {
    if (this.commonService?.isMobileDevice) {
      this.commonService.isHidden = true;
    }
    this.router.navigate(sub?.url);
  }
}
